import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~environment';
import { HttpRequestService } from '~shared/servicios/HttpRequestService';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  private readonly apiTriidyUrlSales = `${environment.apiTriidyUrlSales}`;
  private readonly triidyServiceUrl = `${environment.apiTriidyUrl}`;
  private readonly triidyServiceUrlRest = `${environment.apiTriidyUrlRestSales}/api`;

  id: number;

  url: string = 'http://200.69.100.66/ServicioRESTConsultaEstados/Service1Consulta.svc/ConsultaGuia';
  url2: string = 'http://200.69.100.66/ServicioRESTConsultaEstados/Service1Consulta.svc/ConsultarGuia';

  constructor(protected http: HttpClient, private httpRequestService: HttpRequestService) { }

  getTrack(id: any): Observable<any> {
    return this.http.get<any>(`${this.url2}/${id}/1`).pipe(map((res) => {
      // console.log(res);
      return res;
    })
    );
  }

  getTrackOp(id: any): Observable<any> {
    return this.http.get<any>(`${this.url2}/${id}/2`).pipe(map((res) => {
      // console.log(res);
      return res;
    })
    );
  }

  getTrack2(id: any) {
    return this.http.get(`${this.url2}/${id}/2`);
  }

  getTrackServientrega(guia: any): Observable<any> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      guia,
      token,
    });
    return this.http
      .get<any>(`${this.triidyServiceUrl}/tracking_servientrega`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          return respuesta;
        })
      );
  }

  getTrackEnvia(tipo, guia): Observable<any[]> {
    const token = environment.serviceToken;
    const params = this.httpRequestService.getHttpParamsRequestParams({
      tipo,
      guia,
    });
    return this.http
      .get<any[]>(`${this.triidyServiceUrl}/tracking_envia`, {
        params,
      })
      .pipe(
        map((respuesta) => {
          return respuesta;
        })
      );
  }
}
